"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class InfoApi extends runtime.BaseAPI {
    /**
     * This method retrieves information about the Jira Service Management instance such as software version, builds, and related links.  **[Permissions](#permissions) required**: None, the user does not need to be logged in.
     * Get info
     */
    getInfoRaw(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", []);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/info`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.SoftwareInfoDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method retrieves information about the Jira Service Management instance such as software version, builds, and related links.  **[Permissions](#permissions) required**: None, the user does not need to be logged in.
     * Get info
     */
    getInfo(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getInfoRaw(initOverrides);
            return yield response.value();
        });
    }
}
exports.InfoApi = InfoApi;
//# sourceMappingURL=InfoApi.js.map